import React from "react";
import { Check, X } from "lucide-react";

const ROWS = [
  {
    label: "Throughput",
    legacy: "One machine at a time, an operator clicking through each",
    poofed: "Dozens wiped in parallel — connect once and walk away",
  },
  {
    label: "Setup & training",
    legacy: "Long install, steep learning curve, certified operators",
    poofed: "Pre-configured, plug-and-play stations — minimal training",
  },
  {
    label: "Choosing the method",
    legacy: "The operator picks the standard — and can pick the wrong one",
    poofed: "Automatic per-drive method selection — no human error",
  },
  {
    label: "Failed wipes",
    legacy: "A failed erase can still burn a paid license",
    poofed: "You're never charged for a failed wipe",
  },
  {
    label: "Pricing",
    legacy: "Per-device / per-seat licenses that add up fast",
    poofed: "Flat monthly subscription, volume discounts for enterprise",
  },
  {
    label: "The bigger picture",
    legacy: "A standalone wipe and a PDF",
    poofed: "Full cycle — erase, reinstall, drivers, assessment, certificate, label",
  },
];

const VsLegacy = () => {
  return (
    <section id="compare" className="relative bg-brand-bg font-body">
      <div className="mx-auto max-w-6xl px-6 py-20 lg:py-28">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-white px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-brand-plum">
            Why Poofed
          </span>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-brand-plum sm:text-4xl lg:text-5xl">
            Built for a Refurb Line, Not a <span className="text-brand-gradient">Single Desk</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink sm:text-lg">
            Legacy, license-based erasure software was built for IT departments wiping one machine at a time.
            For a high-volume refurb line, that model works against you.
          </p>
        </div>

        {/* comparison table */}
        <div className="mt-12 overflow-hidden rounded-3xl border border-line bg-white shadow-sm">
          {/* header row */}
          <div className="grid grid-cols-1 sm:grid-cols-[1.1fr_1fr_1fr]">
            <div className="hidden border-b border-line bg-brand-bg px-6 py-4 sm:block" />
            <div className="border-b border-line bg-brand-bg px-6 py-4">
              <span className="font-display text-sm font-semibold text-muted">Legacy erasure software</span>
            </div>
            <div className="border-b border-line bg-brand-plum px-6 py-4">
              <span className="font-display text-sm font-semibold text-white">Furloop Poofed</span>
            </div>
          </div>

          {ROWS.map(({ label, legacy, poofed }, i) => (
            <div
              key={label}
              className={`grid grid-cols-1 sm:grid-cols-[1.1fr_1fr_1fr] ${
                i < ROWS.length - 1 ? "border-b border-line" : ""
              }`}
            >
              <div className="bg-brand-bg/60 px-6 py-4 sm:bg-transparent">
                <span className="font-display text-sm font-semibold text-brand-plum">{label}</span>
              </div>
              <div className="flex items-start gap-2 px-6 py-4">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-danger" />
                <span className="text-sm leading-relaxed text-muted">{legacy}</span>
              </div>
              <div className="flex items-start gap-2 bg-brand-wash/30 px-6 py-4">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-success" />
                <span className="text-sm leading-relaxed text-brand-plum">{poofed}</span>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 max-w-3xl text-sm leading-relaxed text-muted">
          And because Poofed is <span className="font-medium text-brand-plum">built and owned by Furloop</span>{" "}
          — not licensed from a vendor — your certificates and device data stay in your cloud, the certificate
          carries your brand, and new features ship fast instead of waiting on a vendor&apos;s release cycle.
        </p>
      </div>
    </section>
  );
};

export default VsLegacy;
